module.exports = __webpack_public_path__ + "static/media/sf-map.c0a09a5a.gif";